import * as i0 from '@angular/core';
import * as i1 from './calendar-kit.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '../button/button.component';
import * as i6 from './components/calendar-header/calendar-header.component';
import * as i7 from './components/calendar-navigation/calendar-navigation.component';
import * as i8 from './components/calendar-navigation/calendar-pageable-navigation.component';
import * as i9 from './components/calendar-days-names/calendar-days-names.component';
import * as i10 from './components/calendar-year-picker/calendar-year-picker.component';
import * as i11 from './components/calendar-month-picker/calendar-month-picker.component';
import * as i12 from './components/calendar-day-picker/calendar-day-picker.component';
import * as i13 from './components/calendar-day-picker/calendar-day-cell.component';
import * as i14 from './components/calendar-month-picker/calendar-month-cell.component';
import * as i15 from './components/calendar-year-picker/calendar-year-cell.component';
import * as i16 from './components/calendar-picker/calendar-picker-row.component';
import * as i17 from './components/calendar-picker/calendar-picker.component';
import * as i18 from '../shared/shared.module';
import * as i19 from '../button/button.module';
export const NbCalendarKitModuleNgFactory:i0.NgModuleFactory<i1.NbCalendarKitModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_bh = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_s = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵangular_packages_forms_forms_be = (<any>(null as any));
var _decl0_16:i3.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.NgFormSelectorWarning = (<any>(null as any));
var _decl0_33:i4.RouterOutlet = (<any>(null as any));
var _decl0_34:i4.RouterLink = (<any>(null as any));
var _decl0_35:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_36:i4.RouterLinkActive = (<any>(null as any));
var _decl0_37:i4.ɵEmptyOutletComponent = (<any>(null as any));
var _decl0_38:i5.NbButtonComponent = (<any>(null as any));
var _decl0_39:i6.NbCalendarHeaderComponent<any> = (<any>(null as any));
var _decl0_40:i7.NbCalendarNavigationComponent<any> = (<any>(null as any));
var _decl0_41:i8.NbCalendarPageableNavigationComponent<any> = (<any>(null as any));
var _decl0_42:i9.NbCalendarDaysNamesComponent<any> = (<any>(null as any));
var _decl0_43:i10.NbCalendarYearPickerComponent<any> = (<any>(null as any));
var _decl0_44:i11.NbCalendarMonthPickerComponent<any,any> = (<any>(null as any));
var _decl0_45:i12.NbCalendarDayPickerComponent<any,any> = (<any>(null as any));
var _decl0_46:i13.NbCalendarDayCellComponent<any> = (<any>(null as any));
var _decl0_47:i14.NbCalendarMonthCellComponent<any> = (<any>(null as any));
var _decl0_48:i15.NbCalendarYearCellComponent<any> = (<any>(null as any));
var _decl0_49:i16.NbCalendarPickerRowComponent<any,any> = (<any>(null as any));
var _decl0_50:i17.NbCalendarPickerComponent<any,any> = (<any>(null as any));
var _decl0_51:i2.AsyncPipe = (<any>(null as any));
var _decl0_52:i2.UpperCasePipe = (<any>(null as any));
var _decl0_53:i2.LowerCasePipe = (<any>(null as any));
var _decl0_54:i2.JsonPipe = (<any>(null as any));
var _decl0_55:i2.SlicePipe = (<any>(null as any));
var _decl0_56:i2.DecimalPipe = (<any>(null as any));
var _decl0_57:i2.PercentPipe = (<any>(null as any));
var _decl0_58:i2.TitleCasePipe = (<any>(null as any));
var _decl0_59:i2.CurrencyPipe = (<any>(null as any));
var _decl0_60:i2.DatePipe = (<any>(null as any));
var _decl0_61:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_62:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_63:i2.KeyValuePipe = (<any>(null as any));
var _decl0_64:i18.NbSharedModule = (<any>(null as any));
var _decl0_65:i19.NbButtonModule = (<any>(null as any));
var _decl0_66:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_67:i0.ElementRef<any> = (<any>(null as any));
function _View_NbCalendarHeaderComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NbCalendarHeaderComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_60.transform(_decl0_39.date,'mediumDate');
  currVal_0;
  const currVal_1:any = {'nb-arrow-dropright':_decl0_39.isLtr,'nb-arrow-dropleft':_decl0_39.isRtl};
  currVal_1;
  const pd_2:any = ((<any>_decl0_39.navigateToday.emit()) !== false);
}
function _View_NbCalendarNavigationComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_NbCalendarNavigationComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_38.xsmall;
  currVal_0;
  const currVal_1:any = _decl0_38.small;
  currVal_1;
  const currVal_2:any = _decl0_38.medium;
  currVal_2;
  const currVal_3:any = _decl0_38.large;
  currVal_3;
  const currVal_4:any = _decl0_38.primary;
  currVal_4;
  const currVal_5:any = _decl0_38.info;
  currVal_5;
  const currVal_6:any = _decl0_38.success;
  currVal_6;
  const currVal_7:any = _decl0_38.warning;
  currVal_7;
  const currVal_8:any = _decl0_38.danger;
  currVal_8;
  const currVal_9:any = _decl0_38.rectangle;
  currVal_9;
  const currVal_10:any = _decl0_38.round;
  currVal_10;
  const currVal_11:any = _decl0_38.semiRound;
  currVal_11;
  const currVal_12:any = _decl0_38.hero;
  currVal_12;
  const currVal_13:any = _decl0_38.outline;
  currVal_13;
  const currVal_14:any = _decl0_38.disabled;
  currVal_14;
  const currVal_15:any = _decl0_38.disabled;
  currVal_15;
  const currVal_16:any = _decl0_38.tabbable;
  currVal_16;
  const currVal_17:any = _decl0_38.fullWidth;
  currVal_17;
  const currVal_18:any = _decl0_60.transform(_decl0_40.date,'MMM yyyy');
  currVal_18;
  const pd_19:any = ((<any>_decl0_38.onClick(_any)) !== false);
  const pd_20:any = ((<any>_decl0_40.changeMode.emit()) !== false);
}
function _View_NbCalendarPageableNavigationComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_NbCalendarPageableNavigationComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = {'nb-arrow-left':_decl0_41.isLtr,'nb-arrow-right':_decl0_41.isRtl};
  currVal_0;
  const currVal_1:any = _decl0_41.date;
  currVal_1;
  const currVal_2:any = {'nb-arrow-right':_decl0_41.isLtr,'nb-arrow-left':_decl0_41.isRtl};
  currVal_2;
  const pd_3:any = ((<any>_decl0_41.prev.emit()) !== false);
  const pd_4:any = ((<any>_decl0_41.changeMode.emit()) !== false);
  const pd_5:any = ((<any>_decl0_41.next.emit()) !== false);
}
function _View_NbCalendarDaysNamesComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_NbCalendarDaysNamesComponent_4_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.isHoliday;
  currVal_0;
  const currVal_1:any = _any.name;
  currVal_1;
}
function _View_NbCalendarDaysNamesComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_42.days;
  currVal_0;
}
function _View_NbCalendarYearPickerComponent_Host_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_43.medium;
  currVal_0;
  const currVal_1:any = _decl0_43.large;
  currVal_1;
}
function _View_NbCalendarYearPickerComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_43.years;
  currVal_0;
  const currVal_1:any = _decl0_43.year;
  currVal_1;
  const currVal_2:any = _decl0_43.date;
  currVal_2;
  const currVal_3:any = _decl0_43.cellComponent;
  currVal_3;
  const currVal_4:any = _decl0_43.min;
  currVal_4;
  const currVal_5:any = _decl0_43.max;
  currVal_5;
  const currVal_6:any = _decl0_43.filter;
  currVal_6;
  const pd_7:any = ((<any>_decl0_43.onSelect(_any)) !== false);
}
function _View_NbCalendarMonthPickerComponent_Host_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_44.medium;
  currVal_0;
  const currVal_1:any = _decl0_44.large;
  currVal_1;
}
function _View_NbCalendarMonthPickerComponent_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_44.months;
  currVal_0;
  const currVal_1:any = _decl0_44.month;
  currVal_1;
  const currVal_2:any = _decl0_44.cellComponent;
  currVal_2;
  const currVal_3:any = _decl0_44.min;
  currVal_3;
  const currVal_4:any = _decl0_44.max;
  currVal_4;
  const currVal_5:any = _decl0_44.filter;
  currVal_5;
  const pd_6:any = ((<any>_decl0_44.onSelect(_any)) !== false);
}
function _View_NbCalendarDayPickerComponent_Host_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_45.medium;
  currVal_0;
  const currVal_1:any = _decl0_45.large;
  currVal_1;
}
function _View_NbCalendarDayPickerComponent_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_45.weeks;
  currVal_0;
  const currVal_1:any = _decl0_45.visibleDate;
  currVal_1;
  const currVal_2:any = _decl0_45.date;
  currVal_2;
  const currVal_3:any = _decl0_45.cellComponent;
  currVal_3;
  const currVal_4:any = _decl0_45.min;
  currVal_4;
  const currVal_5:any = _decl0_45.max;
  currVal_5;
  const currVal_6:any = _decl0_45.filter;
  currVal_6;
  const pd_7:any = ((<any>_decl0_45.onSelect(_any)) !== false);
}
function _View_NbCalendarDayCellComponent_Host_8_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_46.today;
  currVal_0;
  const currVal_1:any = _decl0_46.boundingMonth;
  currVal_1;
  const currVal_2:any = _decl0_46.selected;
  currVal_2;
  const currVal_3:any = _decl0_46.empty;
  currVal_3;
  const currVal_4:any = _decl0_46.disabled;
  currVal_4;
  const pd_5:any = ((<any>_decl0_46.onClick()) !== false);
}
function _View_NbCalendarDayCellComponent_8_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_46.day;
  currVal_0;
}
function _View_NbCalendarMonthCellComponent_Host_9_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_47.selected;
  currVal_0;
  const currVal_1:any = _decl0_47.today;
  currVal_1;
  const currVal_2:any = _decl0_47.disabled;
  currVal_2;
  const pd_3:any = ((<any>_decl0_47.onClick()) !== false);
}
function _View_NbCalendarMonthCellComponent_9_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_47.month;
  currVal_0;
}
function _View_NbCalendarYearCellComponent_Host_10_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_48.selected;
  currVal_0;
  const currVal_1:any = _decl0_48.today;
  currVal_1;
  const currVal_2:any = _decl0_48.disabled;
  currVal_2;
  const pd_3:any = ((<any>_decl0_48.onClick()) !== false);
}
function _View_NbCalendarYearCellComponent_10_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_48.year;
  currVal_0;
}
function _View_NbCalendarPickerRowComponent_Host_11_0():void {
  var _any:any = (null as any);
}
function _View_NbCalendarPickerRowComponent_11_1():void {
  var _any:any = (null as any);
}
function _View_NbCalendarPickerRowComponent_11_0():void {
  var _any:any = (null as any);
}
function _View_NbCalendarPickerComponent_Host_12_0():void {
  var _any:any = (null as any);
}
function _View_NbCalendarPickerComponent_12_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any;
  currVal_0;
  const currVal_1:any = _decl0_50.selectedValue;
  currVal_1;
  const currVal_2:any = _decl0_50.visibleDate;
  currVal_2;
  const currVal_3:any = _decl0_50.cellComponent;
  currVal_3;
  const currVal_4:any = _decl0_50.min;
  currVal_4;
  const currVal_5:any = _decl0_50.max;
  currVal_5;
  const currVal_6:any = _decl0_50.filter;
  currVal_6;
  const pd_7:any = ((<any>_decl0_50.select.emit(_any)) !== false);
}
function _View_NbCalendarPickerComponent_12_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_50.data;
  currVal_0;
}
